/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { gameGetGameMinecraftHistoryid } from "../../funcs/gameGetGameMinecraftHistoryid.js";
import { GetGameMinecraftHistoryidRequest$zodSchema } from "../../models/getgameminecrafthistoryidop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetGameMinecraftHistoryidRequest$zodSchema.optional(),
};

export const tool$gameGetGameMinecraftHistoryid: ToolDefinition<typeof args> = {
  name: "game-get-game-minecraft-historyid",
  description: `查询 MC 曾用名

想知道某个大佬以前叫什么名字吗？这个接口可以帮你追溯一个 Minecraft 玩家的“黑历史”！

## 功能概述
通过提供玩家的用户名或 UUID，你可以获取到该玩家所有曾用名及其变更时间的列表。这对于识别回归的老玩家或者社区管理非常有用。

## 使用须知
> [!NOTE]
> **参数说明**
> - \`name\` 和 \`uuid\` 二选一
> - UUID 支持带连字符（如 \`ee9b4ed1-aac1-491e-b761-1471be374b80\`）或不带连字符格式

> [!IMPORTANT]
> **响应结构差异**
> - 使用 \`uuid\` 查询：返回单个用户的历史记录
> - 使用 \`name\` 查询：返回所有匹配用户的列表（包括当前用户名或曾用名匹配的玩家），需判断响应中是否有 \`results\` 字段来区分两种模式`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await gameGetGameMinecraftHistoryid(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
